export const createTraySchema = ({ getSizeString, getPriceString }) => {
  return {
    title: 'Tray Details',
    summary: {
      title: 'Details',
      fields: [
        { key: 'brand', label: 'Brand' },
        { key: 'stock', label: 'Stock' },
        {
          key: 'size',
          label: 'Size',
          getValue: (row) => getSizeString(row),
        },
        {
          key: 'price',
          label: 'Price',
          getValue: (row) => getPriceString(row),
        },
      ],
    },
    sections: [
      {
        title: 'Notes',
        fields: [{ key: 'notes', label: 'Notes' }],
      },
    ],
  };
};
